import React from 'react';
import { BrowserRouter, Route, Routes, } from "react-router-dom";

import AccomodationPage from '../AccomodationPage/AccomodationPage';
import BlogDetails from '../BlogDetails';
import BlogDetailsFull from '../BlogDetailsFull';
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide';
import BlogPage from '../BlogPage';
import BlogPageFullwidth from '../BlogPageFullwidth';
import BlogPageLeft from '../BlogPageLeft';
import BrideGroomPage from '../BrideGroomPage/BrideGroomPage';
import ComingSoonPage from '../ComingSoonPage/ComingSoonPage';
import ErrorPage from '../ErrorPage';
import EventPage from '../EventPage/EventPage';
import ForgotPassword from '../ForgotPassword';
import GalleryPage from '../GalleryPage/GalleryPage';
import GalleryPage2 from '../GalleryPage2/GalleryPage2';
import GallerySlide from '../GallerySlide/GallerySlide';
import Homepage from '../HomePage';
import InvitationPage from '../InvitationPage/InvitationPage';
import LoginPage from '../LoginPage';
import RSVPPage from '../RSVPPage/RSVPPage';
import SignUpPage from '../SignUpPage';
import StoryPage from '../StoryPage/StoryPage';
import WeddingDetailsPage from '../WeddingDetailsPage/WeddingDetailsPage';
import WeddingPage from '../WeddingPage/WeddingPage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='home' element={<Homepage />} />
          <Route path='invitation' element={<InvitationPage />} />
          <Route path='wedding' element={<WeddingPage />} />
          <Route path='wedding-details' element={<WeddingDetailsPage />} />
          <Route path='gallery' element={<GalleryPage />} />
          <Route path='gallery-s2' element={<GalleryPage2 />} />
          <Route path='gallery-slide' element={<GallerySlide />} />
          <Route path='rsvp' element={<RSVPPage />} />
          <Route path='story' element={<StoryPage />} />
          <Route path='accomodation' element={<AccomodationPage />} />
          <Route path='event' element={<EventPage />} />
          <Route path='groom-bride' element={<BrideGroomPage />} />
          <Route path='coming' element={<ComingSoonPage />} />
          <Route path='404' element={<ErrorPage />} />
          <Route path='blog-single/:id' element={<BlogDetails />} />
          <Route path='blog-single-left-sidebar/:id' element={<BlogDetailsLeftSiide />} />
          <Route path='blog-single-fullwidth/:id' element={<BlogDetailsFull />} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog-left-sidebar' element={<BlogPageLeft />} />
          <Route path='blog-fullwidth' element={<BlogPageFullwidth />} />
          <Route path='login' element={<LoginPage />} />
          <Route path='register' element={<SignUpPage />} />
          <Route path='forgot-password' element={<ForgotPassword />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
